import React from 'react';

import Icon from '../Icons';

import { Container, ModalContainer, Title, TextContent } from './styles';

const BlockSiteAdvice = () => {
  return (
    <Container>
      <ModalContainer>
        <Title>Olá,</Title>
        <TextContent>
          No momento, não é possível acessar o site Veloe pelo Internet Explorer.
        </TextContent>
        <TextContent>
          Para garantir a melhor experiência,
          recomendamos que você utilize uma das duas últimas versões dos navegadores
          Google Chrome, Mozilla Firefox ou Microsoft Edge.
          Você também pode acessar nosso site pelo seu celular. ;)
        </TextContent>
        <Icon name='LogoVeloe' width={200} />
      </ModalContainer>
    </Container>
  )
}

export default BlockSiteAdvice;
